<template>
    <div class="modal-overlay">
        <!-- 英文模版 -->
        <div class="modal-content" v-if="currentLang === 'EN'">
          <h3>Terms and Conditions</h3>
          <div class="modal-body">
            <br>
            <div>READ THESE TERMS AND CONDITIONS (“Terms”) CAREFULLY BEFORE REGISTERING OR USING THE SERVICES DESCRIBED ON THE WEBSITE LOCATED AT www.chinaamc.com.hk. By clicking the “Accept” button, you consent to be bound by all the terms set out herein. If you do not agree with any of these terms, you are not an authorized user for these services and you should not use this website. Please click “Do not Accept” button and leave this website.</div>
            <br>
            <p>Terms and Conditions</p>
            <br>
            <div>China Asset Management (Hong Kong) Limited (“ChinaAMC HK”) is a regulated institution in Hong Kong by the Securities and Futures Commission (“SFC”) pursuant to the Securities and Futures Ordinance (Cap 571). This website is prepared and owned by ChinaAMC HK and contains information about ChinaAMC HK and the services and products offered by ChinaAMC HK. This website has not been reviewed by the SFC.</div>
            <br>
            <div>This information contained in this website is provided for informational purposes only. Funds information is intended to be made available only to residents in Hong Kong that are not U.S. Persons. If you are an individual investor, you acknowledge that you are a resident of Hong Kong. Funds information is not intended for use by any person located in or residing in any jurisdiction that restrict the use or distribution of such information. Nothing on this website should constitute a distribution, an offer to buy or the solicitation of any offer to buy or sell any securities in any jurisdiction where such a distribution or offer would be illegal. Non-Hong Kong investors are responsible for observing all applicable laws and regulations of their relevant jurisdictions before proceeding to access the information contained herein. By proceeding, you are representing that you have understood and accepted the restrictions set out in this section.</div>
            <br>
            <br>
            <br>
            <div>None of the information contained in this website constitute an invitation or solicitation to invest in any shares or units of the Funds, nor does it constitute any investment advice or recommendation to acquire or dispose of any investment or to engage in any transactions. Before acting on any information in this website, you should consider whether any investment, security or strategy is suitable for your particular circumstance and, if necessary, seek independent professional advice.</div>
            <br>
            <div>Investment involves risks. The price of units or shares of the Funds may go up as well as down. Past performance is not indicative of future results. The value of the Funds can be extremely volatile and could go down substantially within a short period of time. It is possible that the entire value of your investment could be lost. An investment in a Fund often involves investing in international markets. In addition to the normal risks associated with investing, international investments involve the risk of losing all or part of any capital from unfavorable fluctuations in currency values, from differences in generally accepted accounting principles or from economic or political instability in other nations. An investment in emerging markets also involves heightened other risks such as increased volatility and the possibility of lower trading volume. Funds may use or invest in financial derivatives. Please read the Funds’ Prospectuses and Product Key Fact Statements for details, including the risk factors, before making any investment decision.</div>
            <br>
            <div>Where a Fund’s investment objective is to track an index, the Fund is not sponsored, endorsed, issued, sold or promoted by the relevant index provider. None of these companies make any representation regarding the advisability of investing in the Funds. Index returns are for illustrative purposes only and do not represent actual fund performance. Index performance returns do not reflect any management fees, transaction costs or expenses. Indices are unmanaged and one cannot invest directly in an index.</div>
            <br>
            <p>Prohibited Uses</p>
            <br>
            <div>Except as otherwise stated in these Terms or as expressly authorized by ChinaAMC HK in writing, you may not:
                <br>
                <p class="indent">•	Use this website in any manner that could damage or overburden any ChinaAMC server, or any network connected to any ChinaAMC server, as all servers have limited capacity and are used by many people;</p>
                <br>
                <p class="indent">•	Use this website in any manner that would interfere with another party’s use of the Website;</p>
                <br>
                <p class="indent">•	Include the term “ChinaAMC” or any ChinaAMC trademark or executive’s name, or any variation of the foregoing, as a meta-tag, hidden textual element;</p>
                <br>
                <p class="indent">•	Use any robot, spider, intelligent agent, other automatic device, or manual process to search, monitor or copy this website or the reports, data, information, content, software, products services, or other materials on, generated by or obtained from this website, whether through links or otherwise (collectively, “Materials”), without ChinaAMC HK’s permission, provided that generally available third-party web browsers may be used without such permission; or</p>
                <br>
                <p class="indent">•	Use this website or the Materials in any manner that could create impression of affiliation, sponsorship or endorsement by ChinaAMC.</p>
            </div>
            <br>
            <br>
            <br>
            <p>Limitation of Liability</p>
            <br>
            <div>All information contained in this website is published to the best of the knowledge and belief of ChinaAMC HK to be accurate at the time it was posted. However, no representation or warranty, expressed or implied is made by ChinaAMC HK as to its accuracy or completeness of the information or data provided in this website. ChinaAMC HK, its affiliates, directors, officers or employees accept no liability for any errors or omissions relating to information available in this website, and will not be liable for any damages or costs (including but not limited to lost profits, trading losses or damages that result from use or loss of use of this website) arising out of or in any way connected with (i) the use of the information provided in this website and (ii) any interruption or failure in system operation, delay in data transmission, computer virus or line or system failure.</div>
            <br>
            <p>Trademarks, Copyrights and other Intellectual Property</p>
            <br>
            <br>
            <br>
            <div>All copyright, trademarks and similar rights in this website and the information contained herein are owned by or licensed to ChinaAMC HK or its affiliate. Information in or any parts of this website cannot be reproduced, distributed or published.</div>
            <br>
            <p>Jurisdiction and Governing Law</p>
            <br>
            <div>These Terms shall be governed by, and shall be construed in accordance with, the laws of Hong Kong.  The courts of Hong Kong shall have non-exclusive jurisdiction to hear and determine any suit, action or proceeding, and to settle any disputes, which may arise out of or in connection with these Terms and, for such purposes, you agree to submit  to the jurisdiction of the courts of Hong Kong.  Each party hereby waives any objection which it might at any time have to the courts of Hong Kong being nominated as the forum to hear and determine any proceedings and to settle any disputes and agrees not to claim that the courts of Hong Kong are not a convenient or appropriate forum.</div>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p>Privacy Statement</p>
            <br>
            <div>We understand that our customers and website visitors are concerned about the privacy of information. The following information is designed to help you understand the information collection practices at this Website.</div>
            <br>
            <div>By visiting this Website, you are accepting the practices described in this Privacy Policy. If you do not agree to the below policy, please do not use this Website.</div>
            <br>
            <div>ChinaAMC HK recognizes the importance of personal data to our business and the importance of respecting the privacy rights of our clients. Therefore, we are committed to ensuring compliance with the requirements of the Personal Data (Privacy) Ordinance (the “Ordinance”). Each employee of ChinaAMC HK must abide by our commitment to privacy in the handling of personal information. To further enhance confidentiality and security of all personal data, only authorized staff will be allowed to have access to the personal information collected. It is restricted to those persons who have a business need to access personal information in order to perform their job duties.</div>
            <br>
            <div>The purpose of this Statement is to establish the policies and practices of ChinaAMC HK’s commitment to protect the privacy of personal data and to inform you about our responsibilities and your rights under the Ordinance.</div>
            <br>
            <p>Types of Personal Data Held</p>
            <br>
            <div>Personal data held by us regarding clients may include the following:-
                <br>
                <p class="indent">•	Name and address, occupation, contact details, date of birth, their identity card or passport numbers;</p>
                <br>
                <p class="indent">•	Current employer, nature of position, relevant income of clients;</p>
                <br>
                <p class="indent">•	Details of financial status of clients; and</p>
                <br>
                <p class="indent">•	Information obtained by us in the ordinary course of the business relationship such as, investment options, account values and balances etc.</p>
            </div>
            <br>
            <p>Main Purposes of keeping Personal Data</p>
            <br>
            <div>The purposes for which personal data relating to clients may be used are as follows:-
                <br>
                <br>
                <p class="indent">•	Facilitate the daily operations of the services provided to the clients;</p>
                <br>
                <p class="indent">•	Marketing investment products or services provided by ChinaAMC (HK);</p>
                <br>
                <p class="indent">•	Maintaining statistical data and providing a database for product and market research;</p>
                <br>
                <p class="indent">•	Marketing financial and/or investment products or services by any company/companies other than ChinaAMC HK, subject to client’s express prior written consent;</p>
                <br>
                <p class="indent">•	Compliance with applicable laws and regulations; and</p>
                <br>
                <p class="indent">•	Any other purposes relating or incidental thereto.</p>
            </div>
            <br>
            <p>Transfer of Personal Data </p>
            <br>
            <div>Personal data held by ChinaAMC HK relating to clients will be kept confidential but may be transferred to the following parties (whether within or outside the Hong Kong Special Administrative Region) for any of the purposes stated above:-
                <br>
                <p class="indent">•	Any agent, contractor, third party service provider or any member company of ChinaAMC HK which provides administrative, telecommunications, computer, marketing, professional or other services to ChinaAMC HK in connection with its business operations;</p>
                <br>
                <p class="indent">•	Any person to whom ChinaAMC HK is under an obligation to make disclosure under the requirements of any law binding on ChinaAMC HK or any of its member companies or under and for the purposes of any guidelines issued by regulatory or other authorities with which ChinaAMC HK or its member companies are expected to comply;</p>
                <br>
                <p class="indent">•	Any actual or proposed assignee of ChinaAMC HK or participant or sub-participant or transferee of ChinaAMC HK’s rights in respect of the client; and</p>
                <br>
                <p class="indent">•	Any persons or bodies corporate under a duty of confidentiality to ChinaAMC HK.</p>
            </div>
            <br>
            <p>Accuracy of Personal Data </p>
            <br>
            <div>ChinaAMC HK strive at all times to ensure accuracy of all personal data collected and processed by us. In order to assist us to deliver on this pledge, please inform us immediately in the event that your personal information has been changed or you discovered that your personal information held by us is incorrect.</div>
            <br>
            <p>Your Rights</p>
            <br>
            <div>It is not a statutory requirement for you to provide personal data to us. However, we will not be able to provide you with the services and products you may require unless you provide us with the necessary personal data or information.</div>
            <br>
            <div>You have a right (i) to be informed whether we hold any of your personal data; (ii) to be supplied with a copy of your personal data we hold; and (iii) to request correction of your personal data we hold. If you wish to access to and/or to correct any of your personal data held by us, please send your written request to the address set out below. We may, subject to the Ordinance, impose a reasonable fee for complying with a data access request.</div>
            <br>
            <div>If you do not wish your personal data to be used for direct marketing purposes, you may notify us in writing to the following address:-
                <br>
                <br>
                <p class="indent">Head of Legal & Compliance</p>
                <p class="indent">China Asset Management (Hong Kong) Limited</p>
                <p class="indent">37/F, Bank of China Tower,</p>
                <p class="indent">1 Garden Road, Central</p>
                <p class="indent">Hong Kong</p>
            </div>
            <br>
          </div>
          
          <div class="modal-footer">
            <div  @click="handleAccept">Agree</div>
            <div  @click="handleReject">Not agree</div>
          </div>
        </div>
        <!-- 繁体模版 -->
        <div class="modal-content" v-if="currentLang === 'TC'">
          <h3>條款及細則</h3>
          <div class="modal-body">
            <br>
            <div>在閣下於本網站www.chinaamc.com.hk 註冊或使用本網站中所刊載的服務前，請您仔細閱讀此條款及細則（「條款」）。當您點擊「同意」按鈕，即代表閣下同意接受本文所列出的條款的約束。如果您不同意任何本文所列的條款，則您不是這些服務的授權用戶，不應使用本網站；請點擊「不同意」按鈕，並離開本網站。</div>
            <br>
            <p>條款及細則</p>
            <br>
            <div>華夏基金（香港）有限公司（「華夏香港」）是受香港證券及期貨事務監察委員會（「香港證監會」）根據《證券及期貨條例》（第571章）監管的公司。本網站由華夏香港編制及擁有，包含華夏香港的有關資訊及華夏香港所提供的產品及服務資訊。本網站所載之內容並未經證監會審閱。</div>
            <br>
            <div>本網站所刊載資訊僅供參考之用。有關基金資訊僅限於提供予非屬美國人士的香港居民。如果閣下為個人投資者，則閣下確認您為香港居民。有關基金資訊亦不擬提供予置身於或居住於在法律上禁止該等資訊使用或發佈之地區的人士使用。就任何不獲授權進行分銷或要約的司法管轄區，本網站所載資料並不構成在該地區的任何分銷、買賣的要約，或促使買賣的要約。在繼續閱讀本文所含資訊前，非香港投資者有責任遵守其相關司法管轄區的所有適用的法律及法規。若閣下繼續瀏覽本網站，則閣下會被視為您確認已經理解並接受了本部分條款的限制。</div>
            <br>
            <br>
            <br>
            <div>本網站所刊載的任何內容均不構成對基金的任何份額的投資邀約，也不構成對於任何證券的買賣或進行任何買賣交易的投資建議。在使用本網站所載資料以前，閣下須根據個人狀況，確定任何投資、證券或策略是否合適閣下；如有須要，閣下應諮詢獨立專業意見。</div>
            <br>
            <div>投資涉及風險，基金單位價格可升亦可跌，基金過往業績並不表示將來的回報。基金的價值可能會非常波動，並可能於短時間內大幅下跌，閣下亦可能損失全數投資金額。有關基金的投資經常涉及投資國際市場。除一般投資風險外，國際投資亦會因貨幣價值的不利波動，公認會計原則的差異或其他國家的經濟或政治局勢動蕩而承受損失全部或任何部分資金的風險。投資新興市場亦會增加其他風險，例如市場波動加劇及交投可能淡靜。有關基金可能使用或投資於金融衍生工具。在作出任何投資決定之前，請閣下仔細閱讀基金之銷售說明書和產品資料概要，以了解有關基金之詳情及風險因素。</div>
            <br>
            <div>若有關基金的投資目的是追蹤某一指數，該有關基金並不由相關指數的供應商贊助、認可、發行、售賣或推廣。這些公司亦不會為投資有關基金的適當性做出任何陳述。指數回報僅用於說明目的，不代表實際的基金表現。指數表現回報並無計任何管理費用、交易費用或開支。指數不受管理，而任何人士均無法直接投資於指數。</div>
            <br>
            <p>被禁止之用途</p>
            <br>
            <div>除本條款另有聲明或經華夏香港書面明示授權外，閣下不得：
                <br>
                <p class="indent">以可能對華夏香港伺服器或任何連接至華夏香港伺服器的網絡造成損害或過重負擔的任何方式使用本網站，因所有伺服器的承載力有限且供多人使用；</p>
                <br>
                <p class="indent">以任何會對他人對本網站的使用造成幹擾的方式使用本網站；</p>
                <br>
                <p class="indent">將「華夏香港」或任何華夏香港商標或其主管人員的姓名或任何上述的變體，包括進元標簽–一種隱藏的文本元素當中；</p>
                <br>
                <p class="indent">未經華夏香港允許，通過鏈接或其他方式，使用任何網絡機器人、網絡爬蟲、智慧代理、其他自動設備，或手動操作以搜索、監控或複製本網站或本網站所載之報告、數據、資訊、內容、軟件、產品服務，或任何載於、產生於或獲得於本網站的其他材料（統稱「材料」），惟通常使用的第三方網絡瀏覽器不經上述允許便可使用；或者</p>
                <br>
                <p class="indent">以任何可能造成與華夏香港有聯屬關係、贊助關係或認許關係之印象的方式使用本網站或材料。</p>
            </div>
            <br>
            <br>
            <br>
            <p>責任限制</p>
            <br>
            <div>華夏香港已盡其所知及所信，使本網站所載資料在發佈之時為真實準確；但華夏香港並不聲明或保證（不論明示或暗示）有關本網站中所載資訊及數據的準確性及完備性。華夏香港，其聯屬機構，董事，高級職員及僱員對此網站所提供資料的任何錯誤或遺漏並不負有相關責任，亦並不會對任何源自於或有關於（i）使用本網站提供的資訊和（ii）系統運行中斷或故障，數據傳輸延遲，計算機病毒或線路或系統故障而導致的任何損失或費用承擔責任（包括但不限於利潤損失、交易損失或任何因使用或無法使用本網站引致的損害賠償）。</div>
            <br>
            <p>商標、版權和其他知識產權</p>
            <br>
            <br>
            <br>
            <div>本網站所含之版權、商標及類似權益及資訊均為華夏香港及其聯署機構所擁有或註冊。因此，本網站中的任何資訊或內容均不得複製、分發及發佈。</div>
            <br>
            <p>司法管轄區和管轄法律</p>
            <br>
            <div>本條款受香港法律管轄，並依照香港法律予以解釋。香港法院擁有非排他的司法管轄權，可以審理和裁決任何可能由本條款引致的或與本條款有關的訴訟、起訴或訴訟程式，以及解決任何可能由本條款引致的或與本條款有關的爭端，依此，您同意服從香港法院的管轄。各方在此放棄在任何時間反對香港法院被任命為審理和裁決一切訴訟以及解決一切爭端的法院之權利，並同意不會提出香港法院並非方便或合適的法院。</div>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p>私隱聲明</p>
            <br>
            <div>我們明白客戶及網站訪客對於私隱資訊的重視。以下資料旨在幫助閣下了解關於本網站收集資料的守則。</div>
            <br>
            <div>通過瀏覽本網站，閣下同意本私隱聲明所闡述的守則。若閣下不同意本守則，請停止使用本網站。</div>
            <br>
            <div>華夏香港了解個人資訊對於我們的業務發展及尊重客戶私隱權的重要性。因此，我們致力確保遵守《個人資料(私隱)條例》（「條例」）的規定。華夏香港的每位僱員必須遵守我們對處理個人資訊的隱私承諾。為了進一步加強所有個人資料的保密性和安全性，只有經授權的員工方可獲准訪問公司收集到的個人資訊；且該訪問亦僅限於因業務需要而訪問個人資訊以履行其工作職責的人員。</div>
            <br>
            <div>訂立本私隱聲明的目的旨在確立華夏香港全力執行及遵守保障個人資料私隱原則的政策及實務。並告知閣下在私隱條例下有關我們的責任及閣下的權利。</div>
            <br>
            <p>所保存的個人資料類別</p>
            <br>
            <div>我們所保存的客戶資料可能包括以下類別：
                <br>
                <p class="indent">客戶的姓名及地址、職業、聯絡詳情、出生日期、身份証號碼或護照號碼；</p>
                <br>
                <p class="indent">客戶的現時僱主、職位性質、有關入息；</p>
                <br>
                <p class="indent">客戶的財務狀況詳情；及</p>
                <br>
                <p class="indent">我們與客戶在正常業務關係中獲得的資料，如投資選擇、帳戶價值及結餘等。</p>
            </div>
            <br>
            <p>保存個人資料的主要目的</p>
            <br>
            <div>客戶的個人資料可能會用作下列用途：
                <br>
                <br>
                <p class="indent">為客戶提供日常的服務運作；</p>
                <br>
                <p class="indent">推廣華夏香港的投資產品或服務；</p>
                <br>
                <p class="indent">維持統計數據及用作產品及市場研究資料庫；</p>
                <br>
                <p class="indent">在獲得閣下明確的書面同意的前提下，向閣下推廣任何公司/任何除華夏香港以外其他公司的金融及／或投資產品或服務；</p>
                <br>
                <p class="indent">遵守有關法律及規則；及</p>
                <br>
                <p class="indent">其他與任何上述有關的用途。</p>
            </div>
            <br>
            <p>個人資料的轉移</p>
            <br>
            <div>華夏香港對所持有客戶的個人資料會嚴格保密，但有關資料可能轉移予以下的人士（不論在香港特別行政區之內或之外）作為上述所載的任何用途：
                <br>
                <p class="indent">在業務上向華夏香港提供行政、電訊、電腦、市場推廣、專業服務或其他任何服務的代理、承包商、第三方服務供應商或華夏香港所屬集團旗下的任何成員公司；</p>
                <br>
                <p class="indent">根據華夏香港或成員公司所需遵守的法律要求，或按監管機構或其他主管機構要求華夏香港或成員公司需遵守的指引，華夏香港因而有責任要向其披露的任何人士；</p>
                <br>
                <p class="indent">任何華夏香港的實際或潛在承讓人或華夏香港所持客戶權益的參與人、附屬參與人或受讓人；</p>
                <br>
                <p class="indent">任何已向華夏香港承諾保密責任的人士或法團。</p>
            </div>
            <br>
            <p>個人資料的準確性</p>
            <br>
            <div>華夏香港無論何時均致力於確保所有收集及處理的個人資料皆準確無誤。為協助我們達致此承諾，如閣下的個人資料已作出更改或發現我們所持有閣下的個人資料並不正確，請盡快與我們聯絡。</div>
            <br>
            <p>閣下的權利</p>
            <br>
            <div>閣下向我們提供個人資料並非法定規定。然而，除非我們獲得閣下的必要的個人資料或資訊，否則我們將無法向閣下提供閣下可能需要的服務及產品。</div>
            <br>
            <div>閣下有權 (i)知道我們是否保存有閣下的任何個人資料；(ii)要求我們提供我們所保存的該等資料的副本；及 (iii)要求更正我們所保存的該等資料。如閣下希望查閱及／或更正我們所保存的閣下的個人資料，請致函以下地址。根據私隱條例規定，我們可能會為辦理閣下個人資料記錄的查詢收取合理費用。</div>
            <br>
            <div>如閣下不希望個人資料用作直接促銷用途，請致函以下地址以通知我們：
                <br>
                <br>
                <p class="indent">法律及合規主管</p>
                <p class="indent">華夏基金（香港）有限公司</p>
                <p class="indent">中銀大廈37樓</p>
                <p class="indent">香港花園道1號</p>
            </div>
            <br>
          </div>
            
          <div class="modal-footer">
            <div  @click="handleAccept">同意</div>
            <div  @click="handleReject">不同意</div>
          </div>
        </div>
        <!-- 简体模版 -->
        <div class="modal-content" v-if="currentLang === 'SC'">
          <h3>条款及细则</h3>
          <div class="modal-body">
            <br>
            <div>在阁下于本网站www.chinaamc.com.hk 注册或使用本网站中所刊载的服务前，请您仔细阅读此条款及细则（「条款」）。当您点击「同意」按钮，即代表阁下同意接受本文所列出的条款的约束。如果您不同意任何本文所列的条款，则您不是这些服务的授权用户，不应使用本网站；请点击「不同意」按钮，并离开本网站。</div>
            <br>
            <p>条款及细则</p>
            <br>
            <div>华夏基金（香港）有限公司（「华夏香港」）是受香港证券及期货事务监察委员会（「香港证监会」）根据《证券及期货条例》（第571章）监管的公司。本网站由华夏香港编制及拥有，包含华夏香港的有关资讯及华夏香港所提供的产品及服务资讯。本网站所载之内容并未经证监会审阅。</div>
            <br>
            <div>本网站所刊载资讯仅供参考之用。有关基金资讯仅限于提供予非属美国人士的香港居民。如果阁下为个人投资者，则阁下确认您为香港居民。有关基金资讯亦不拟提供予置身于或居住于在法律上禁止该等资讯使用或发布之地区的人士使用。就任何不获授权进行分销或要约的司法管辖区，本网站所载资料并不构成在该地区的任何分销、买卖的要约，或促使买卖的要约。在继续阅读本文所含资讯前，非香港投资者有责任遵守其相关司法管辖区的所有适用的法律及法规。若阁下继续浏览本网站，则阁下会被视为您确认已经理解并接受了本部分条款的限制。</div>
            <br>
            <br>
            <br>
            <div>本网站所刊载的任何内容均不构成对基金的任何份额的投资邀约，也不构成对于任何证券的买卖或进行任何买卖交易的投资建议。在使用本网站所载资料以前，阁下须根据个人状况，确定任何投资、证券或策略是否合适阁下；如有须要，阁下应咨询独立专业意见。</div>
            <br>
            <div>投资涉及风险，基金单位价格可升亦可跌，基金过往业绩并不表示将来的回报。基金的价值可能会非常波动，并可能于短时间内大幅下跌，阁下亦可能损失全数投资金额。有关基金的投资经常涉及投资国际市场。除一般投资风险外，国际投资亦会因货币价值的不利波动，公认会计原则的差异或其他国家的经济或政治局势动荡而承受损失全部或任何部分资金的风险。投资新兴市场亦会增加其他风险，例如市场波动加剧及交投可能淡静。有关基金可能使用或投资于金融衍生工具。在作出任何投资决定之前，请阁下仔细阅读基金之销售说明书和产品资料概要，以了解有关基金之详情及风险因素。</div>
            <br>
            <div>若有关基金的投资目的是追踪某一指数，该有关基金并不由相关指数的供应商赞助、认可、发行、售卖或推广。这些公司亦不会为投资有关基金的适当性做出任何陈述。指数回报仅用于说明目的，不代表实际的基金表现。指数表现回报并无计任何管理费用、交易费用或开支。指数不受管理，而任何人士均无法直接投资于指数。</div>
            <br>
            <p>被禁止之用途</p>
            <br>
            <div>除本条款另有声明或经华夏香港书面明示授权外，阁下不得：
                <br>
                <p class="indent">以可能对华夏香港伺服器或任何连接至华夏香港伺服器的网络造成损害或过重负担的任何方式使用本网站，因所有伺服器的承载力有限且供多人使用；</p>
                <br>
                <p class="indent">以任何会对他人对本网站的使用造成干扰的方式使用本网站；</p>
                <br>
                <p class="indent">将「华夏香港」或任何华夏香港商标或其主管人员的姓名或任何上述的变体，包括进元标签 – 一种隐藏的文本元素当中；</p>
                <br>
                <p class="indent">未经华夏香港允许，通过链接或其他方式，使用任何网络机器人、网络爬虫、智慧代理、其他自动设备，或手动操作以搜索、监控或复制本网站或本网站所载之报告、数据、资讯、内容、软件、产品服务，或任何载于、产生于或获得于本网站的其他材料（统称「材料」），惟通常使用的第三方网络浏览器不经上述允许便可使用；或者</p>
                <br>
                <p class="indent">以任何可能造成与华夏香港有联属关系、赞助关系或认许关系之印象的方式使用本网站或材料。</p>
            </div>
            <br>
            <br>
            <br>
            <p>责任限制</p>
            <br>
            <div>华夏香港已尽其所知及所信，使本网站所载资料在发布之时为真实准确；但华夏香港并不声明或保证（不论明示或暗示）有关本网站中所载资讯及数据的准确性及完备性。华夏香港，其联属机构，董事，高级职员及雇员对此网站所提供资料的任何错误或遗漏并不负有相关责任，亦并不会对任何源自于或有关于（i）使用本网站提供的资讯和（ii）系统运行中断或故障，数据传输延迟，计算机病毒或线路或系统故障而导致的任何损失或费用承担责任（包括但不限于利润损失、交易损失或任何因使用或无法使用本网站引致的损害赔偿）。</div>
            <br>
            <p>商标、版权和其他知识产权</p>
            <br>
            <br>
            <br>
            <div>本网站所含之版权、商标及类似权益及资讯均为华夏香港及其联署机构所拥有或注册。因此，本网站中的任何资讯或内容均不得复制、分发及发布。</div>
            <br>
            <p>司法管辖区和管辖法律</p>
            <br>
            <div>本条款受香港法律管辖，并依照香港法律予以解释。香港法院拥有非排他的司法管辖权，可以审理和裁决任何可能由本条款引致的或与本条款有关的诉讼、起诉或诉讼程式，以及解决任何可能由本条款引致的或与本条款有关的争端，依此，您同意服从香港法院的管辖。各方在此放弃在任何时间反对香港法院被任命为审理和裁决一切诉讼以及解决一切争端的法院之权利，并同意不会提出香港法院并非方便或合适的法院。</div>
            <br>
            <br>
            <br>
            <br>
            <br>
            <p>私隐声明</p>
            <br>
            <div>我们明白客户及网站访客对于私隐资讯的重视。以下资料旨在帮助阁下了解关于本网站收集资料的守则。</div>
            <br>
            <div>通过浏览本网站，阁下同意本私隐声明所阐述的守则。若阁下不同意本守则，请停止使用本网站。</div>
            <br>
            <div>华夏香港了解个人资讯对于我们的业务发展及尊重客户私隐权的重要性。因此，我们致力确保遵守《个人资料(私隐)条例》（「条例」）的规定。华夏香港的每位雇员必须遵守我们对处理个人资讯的隐私承诺。为了进一步加强所有个人资料的保密性和安全性，只有经授权的员工方可获准访问公司收集到的个人资讯；且该访问亦仅限于因业务需要而访问个人资讯以履行其工作职责的人员。</div>
            <br>
            <div>订立本私隐声明的目的旨在确立华夏香港全力执行及遵守保障个人资料私隐原则的政策及实务。并告知阁下在私隐条例下有关我们的责任及阁下的权利。</div>
            <br>
            <p>所保存的个人资料类别</p>
            <br>
            <div>我们所保存的客户资料可能包括以下类别：
                <br>
                <p class="indent">客户的姓名及地址、职业、联络详情、出生日期、身份证号码或护照号码；</p>
                <br>
                <p class="indent">客户的现时雇主、职位性质、有关入息；</p>
                <br>
                <p class="indent">客户的财务状况详情；及</p>
                <br>
                <p class="indent">我们与客户在正常业务关系中获得的资料，如投资选择、帐户价值及结余等。</p>
            </div>
            <br>
            <p>保存个人资料的主要目的</p>
            <br>
            <div>客户的个人资料可能会用作下列用途：
                <br>
                <br>
                <p class="indent">为客户提供日常的服务运作；</p>
                <br>
                <p class="indent">推广华夏香港的投资产品或服务；</p>
                <br>
                <p class="indent">维持统计数据及用作产品及市场研究资料库；</p>
                <br>
                <p class="indent">在获得阁下明确的书面同意的前提下，向阁下推广任何公司/任何除华夏香港以外其他公司的金融及／或投资产品或服务；</p>
                <br>
                <p class="indent">遵守有关法律及规则；及</p>
                <br>
                <p class="indent">其他与任何上述有关的用途。</p>
            </div>
            <br>
            <p>个人资料的转移</p>
            <br>
            <div>华夏香港对所持有客户的个人资料会严格保密，但有关资料可能转移予以下的人士（不论在香港特别行政区之内或之外）作为上述所载的任何用途：
                <br>
                <p class="indent">在业务上向华夏香港提供行政、电讯、电脑、市场推广、专业服务或其他任何服务的代理、承包商、第三方服务供应商或华夏香港所属集团旗下的任何成员公司；</p>
                <br>
                <p class="indent">根据华夏香港或成员公司所需遵守的法律要求，或按监管机构或其他主管机构要求华夏香港或成员公司需遵守的指引，华夏香港因而有责任要向其披露的任何人士；</p>
                <br>
                <p class="indent">任何华夏香港的实际或潜在承让人或华夏香港所持客户权益的参与人、附属参与人或受让人；</p>
                <br>
                <p class="indent">任何已向华夏香港承诺保密责任的人士或法团。</p>
            </div>
            <br>
            <p>个人资料的准确性</p>
            <br>
            <div>华夏香港无论何时均致力于确保所有收集及处理的个人资料皆准确无误。为协助我们达致此承诺，如阁下的个人资料已作出更改或发现我们所持有阁下的个人资料并不正确，请尽快与我们联络。</div>
            <br>
            <p>阁下的权利</p>
            <br>
            <div>阁下向我们提供个人资料并非法定规定。然而，除非我们获得阁下的必要的个人资料或资讯，否则我们将无法向阁下提供阁下可能需要的服务及产品。</div>
            <br>
            <div>阁下有权 (i)知道我们是否保存有阁下的任何个人资料；(ii)要求我们提供我们所保存的该等资料的副本；及 (iii)要求更正我们所保存的该等资料。如阁下希望查阅及／或更正我们所保存的阁下的个人资料，请致函以下地址。根据私隐条例规定，我们可能会为办理阁下个人资料记录的查询收取合理费用。</div>
            <br>
            <div>如阁下不希望个人资料用作直接促销用途，请致函以下地址以通知我们：
                <br>
                <br>
                <p class="indent">法律及合规主管</p>
                <p class="indent">华夏基金（香港）有限公司</p>
                <p class="indent">中银大厦37楼</p>
                <p class="indent">香港花园道1号</p>
            </div>
            <br>
          </div>
            
          <div class="modal-footer">
            <div  @click="handleAccept">同意</div>
            <div  @click="handleReject">不同意</div>
          </div>
        </div>
      </div>
  </template>
  
  <script setup>
  import { ref, computed, onMounted, onUnmounted } from 'vue'
  import { globalLanguage } from '@/components/utils/language.js';
  const emit = defineEmits(['accept', 'reject'])
  
  const currentLang = computed(() => globalLanguage.value)
  const handleAccept = () => {
    emit('accept')
  }
  
  const handleReject = () => {
    emit('reject')
  }
  
  onMounted(() => {
    // 阻止滚动
    document.body.style.overflow = 'hidden'
  })
  
  onUnmounted(() => {
    // 组件卸载时恢复滚动
    document.body.style.overflow = ''
  })
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    animation: fadeIn 0.3s ease;
    
  }
  
  .modal-content {
    width: 910px;
    padding: 70px;
    background: #fff;
    border-radius: 23px;
  }
  .modal-content>h3{
    font-size: 35px;
    font-weight: 600;
    margin-bottom: 30px;
  }
  .modal-body{
    height: 435px;
    white-space: pre-wrap;
    overflow: auto;
    font: 13px;
    font-size: 17px;
    font-weight: 400;
    line-height: 1.5;
    color: #394049;
    margin-bottom: 20px;
  }
  .modal-body p{
    white-space: pre-wrap;
  }
  .indent{
    text-indent: 2em;
  }

  .modal-footer {
    display: flex;
    justify-content: left;
    text-align: center;
    font-size: 12px;
  }
  .modal-footer>div{
    padding: 15px 48px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 18px;
    margin-right: 30px;
  }
  .modal-footer>div:nth-child(1){
    background-color: #9A1915;
    border-style: solid;
    border-width: 1px 1px 1px 1px;
    border-color: #9A1915;
    color: #fff;
  }
  .modal-footer>div:nth-child(2){
    color: #000000;
    background-color: #9A191500;
    border-style: solid;
    border-width: 1px 1px 1px 1px;
    border-color: #000000;
  }

  </style>